import React from 'react';
import { StyleSheet, Text } from 'react-native';
import PressableStyled from '../../../../../PressableStyled';
import Colors from '../../../../../../constants/Colors';

interface TabButtonProps {
  selected: boolean,
  onPress: () => void,
  title: string,
}

const TabOption = ({ selected, onPress, title }: TabButtonProps) => <PressableStyled
  onPress={onPress}
  style={[styles.container, selected && styles.containerSelected]}
>
  <Text style={[styles.text, selected && styles.textSelected]}>{title}</Text>
</PressableStyled>;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue300,
    backgroundColor: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
    borderRadius: 4,
    marginBottom: 4,
  },
  text: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlue400,
  },
  containerSelected: {
    backgroundColor: Colors.light.hereworksBlue500,
    borderColor: Colors.light.hereworksBlue500,
  },
  textSelected: {
    color: '#FFF',
  },
});

export default TabOption;
